import PropTypes from 'prop-types'
import React from 'react'

const Add = (props) => {
  return (
    <span className="add-svg-wrapper">
      <svg
        viewBox="0 0 172 172"
        style={{
          fill: props.fill,
          width: props.width,
          height: props.height,
        }}
      >
        <title>PBS-add</title>
        <path
          d="M96 76V1.991A2 2 0 0 0 94.009 0H77.991A1.995 1.995 0 0 0 76 1.991V76H1.991A2 2 0 0 0 0 77.991v16.018C0 95.102.891 96 1.991 96H76v74.009A2 2 0 0 0 77.991 172h16.018A1.995 1.995 0 0 0 96 170.009V96h74.009A2 2 0 0 0 172 94.009V77.991A1.995 1.995 0 0 0 170.009 76H96z"
          fillRule="evenodd"
        />
      </svg>
    </span>
  )
}

Add.propTypes = {
  fill: PropTypes.string,
  height: PropTypes.string,
  width: PropTypes.string,
}

export default Add
